module.exports = __webpack_public_path__ + "static/media/login-leftside-shape.cc97ac21.png";